if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
         this.addEventListener('click', (e) => {
          if (e.target.closest('.product-modal__prev')) {
            this.showPrevious();
          }

          if (e.target.closest('.product-modal__next')) {
            this.showNext();
          }
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();

          this.mediaItems = [...this.querySelectorAll('[data-media-id]')];

          const mediaId = this.openedBy.getAttribute('data-media-id');
          this.currentIndex = this.mediaItems.findIndex(
            item => item.dataset.mediaId === mediaId
          );

          this.scrollToMedia();
      }

      showPrevious() {
         if (this.currentIndex > 0) {
              this.currentIndex--;
              this.scrollToMedia();
            }
        }

        showNext() {
          if (this.currentIndex < this.mediaItems.length - 1) {
              this.currentIndex++;
              this.scrollToMedia();
            }
        }

       updateNavigation() {
          const prevBtn = this.querySelector('.product-modal__prev');
          const nextBtn = this.querySelector('.product-modal__next');

          prevBtn.disabled = this.currentIndex === 0;
          nextBtn.disabled = this.currentIndex === this.mediaItems.length - 1;
        }

        scrollToMedia() {
          this.mediaItems.forEach((item) => item.classList.remove('active'));

          const activeMedia = this.mediaItems[this.currentIndex];
          activeMedia.classList.add('active');

          activeMedia.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center'
          });

         this.updateNavigation();
        }
    }
  );
}
